<template>
  <div class="app-header-component">
    <el-container class="header">
      <el-main class="main">
        <el-menu
          class=menu
          :default-active="$route.path"
          :router="true"
          text-color="#fff"
          active-text-color="#fff"
          mode="horizontal">
          <el-menu-item v-for="(menu, idx) in menuArr" :key="idx" :index="menu.path" class="menu-item"
                        :class="{selected:idx===selectedPageIndex}" @click="clickMenu(idx)">
            {{menu.label}}
          </el-menu-item>
        </el-menu>
      </el-main>
      <el-aside width="190px" class="pic">
        <img class="logo" src="../../assets/logo_white.png" alt="Logo" height="50"/>
        <el-dropdown trigger="hover" placement="top-end">
          <img class="portrait" src="../../assets/portrait.png" alt="Portrait" height="50"/>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="user-name" :disabled=true>
              {{userName}}
            </el-dropdown-item>
            <el-dropdown-item class="user-function" @click.native="switchUser">
              切换帐户
            </el-dropdown-item>
            <el-dropdown-item class="user-function" @click.native="exitUser">
              退出
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-aside>
    </el-container>
  </div>
</template>

<script>
import userAPI from '@/api/user';

export default {
  name: 'app-header-component',
  data: () => ({
    menuArr: [
      { label: '设备管理', path: '/device' },
      { label: '工程面板', path: '/engineering' },
      { label: '文件管理', path: '/file' },
      // { label: '权限管理', path: '/authority' },
    ],
  }),
  computed: {
    selectedPageIndex() {
      return this.$store.getters.getPageIndex;
    },
    userName() {
      return this.$store.getters.getLoginInfo.data.username;
    },
  },
  methods: {
    /**
       * 点击对应的设备，切换详情
       * @param index 设备索引
       */
    clickMenu(index) {
      this.$store.commit('setPageIndex', index);
    },
    switchUser() {
      this.$store.commit('setLoginInfo', { data: { username: '' }, success: false });
      this.$store.commit('setRouterSnapshot', this.$router.history.current.fullPath);
      this.$router.push('/login');
    },
    exitUser() {
      userAPI.logout().then(res => console.log(res));
      this.$message({
        type: 'success',
        message: `再见，${this.userName}，期待下次相聚！`,
      });
      this.$store.commit('setLoginInfo', { data: { username: '' }, success: false });
      this.$router.push('/login');
    },
  },
};
</script>

<style lang="scss">
  @import "../../style/mixin";
  @import "../../style/media";

  .app-header-component {
    background: rgba(221, 221, 221, 0.17);
    width: 100%;
    @include max_800 {
      overflow: hidden;
    }

    .header {
      padding-right: 0;
      height: 60px;

      .main {
        padding: 0;
        overflow: auto;
        @include focus-scroll-bar;

        .menu {
          background: $main-color;
          border-bottom: none;

          .menu-item:hover {
            color: #3389e8 !important;
            font-weight: bolder;
          }

          .selected {
            background: #f7f7f7 !important;
            color: #3389e8 !important;
            font-weight: bold;
          }
        }
      }

      .pic {
        overflow: hidden;
        padding: 0 !important;
        background: $main-color;

        .logo {
          margin-top: 5px;
          margin-bottom: auto;
          margin-right: 25px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/appHeader.vue